"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.every.js");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _btn = _interopRequireDefault(require("./btn"));
var _file = _interopRequireDefault(require("./file"));
var _uploadPic = _interopRequireDefault(require("./uploadPic"));
var _uploadCos = _interopRequireDefault(require("./uploadCos"));
var _uploadWos = _interopRequireDefault(require("./uploadWos"));
var _uplaodWeixin = _interopRequireDefault(require("./uplaodWeixin"));
var _btnMixin = _interopRequireDefault(require("./btn-mixin"));
var _utils = require("../utils");
var _util = require("./util");
/* eslint-disable object-shorthand */
/* eslint-disable arrow-body-style */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-else-return */
/* eslint-disable prefer-destructuring */

// import adapter from '@zz-common/native-adapter';

var adapter;
if (!_utils.isServer) {
  adapter = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}

var COMPONENT_NAME = 'z-upload';
var EVENT_INPUT = 'input';
var EVENT_ADDED = 'files-added';
var EVENT_SUBMITTED = 'file-submitted';
var EVENT_REMOVED = 'file-removed';
var EVENT_SUCCESS = 'file-success';
var EVENT_ERROR = 'file-error';
var EVENT_CLICK = 'file-click';
var EVENT_UPLOADING = 'uploading';
var _default2 = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "z-upload"
    }, [_vm._t("default", [_c('div', {
      staticClass: "z-upload-def z-clearfix",
      class: {
        'is-btn-flex': _vm.isBtnFlex
      }
    }, [_c('upload-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isShowBtn,
        expression: "isShowBtn"
      }]
    }, [_vm._t("btn", null, {
      "slot": "btn"
    })], 2), _vm.draggable ? _c('div', [_c('draggable', {
      attrs: {
        "filter": ".z-wrong",
        "fallbackTolerance": 3
      },
      on: {
        "end": function end(ref) {
          var to = ref.to;
          var from = ref.from;
          var item = ref.item;
          var clone = ref.clone;
          var oldIndex = ref.oldIndex;
          var newIndex = ref.newIndex;
          return _vm.$emit('draggable-end', {
            files: _vm.files,
            to: to,
            from: from,
            item: item,
            clone: clone,
            oldIndex: oldIndex,
            newIndex: newIndex
          });
        }
      },
      model: {
        value: _vm.files,
        callback: function callback($$v) {
          _vm.files = $$v;
        },
        expression: "files"
      }
    }, _vm._l(_vm.files, function (file, index) {
      return _c('upload-file', {
        key: index,
        attrs: {
          "file": file,
          "index-key": index,
          "force-show-process": _vm.forceShowProcess
        },
        on: {
          "click": _vm.fileClick
        }
      });
    }), 1)], 1) : _c('div', _vm._l(_vm.files, function (file, index) {
      return _c('upload-file', {
        key: index,
        attrs: {
          "file": file,
          "index-key": index,
          "force-show-process": _vm.forceShowProcess
        },
        on: {
          "click": _vm.fileClick
        }
      });
    }), 1)], 1)])], 2);
  },
  name: COMPONENT_NAME,
  components: {
    Draggable: _vuedraggable.default,
    UploadBtn: _btn.default,
    UploadFile: _file.default
  },
  mixins: [_btnMixin.default],
  props: {
    draggable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isShowProcess: {
      type: Boolean,
      default: true
    },
    forceShowProcess: {
      type: Boolean,
      default: false
    },
    action: {
      type: [String, Object],
      default: ''
    },
    dropOriginFile: Boolean,
    max: {
      type: Number,
      default: 10
    },
    auto: {
      type: Boolean,
      default: true
    },
    simultaneousUploads: {
      type: Number,
      default: 1
    },
    processFile: {
      type: Function,
      default: function _default(file, cb) {
        cb(file);
      }
    },
    preventDefaultFun: {
      type: Function,
      default: function _default(e, next) {
        next();
      }
    },
    asyncProcessVideoFile: {
      type: Function,
      default: function _default(files, cb) {
        cb(files);
      }
    },
    isShowCoverInfo: {
      type: Boolean,
      default: false
    },
    coverInfoVideo: {
      type: Boolean,
      default: true
    },
    coverInfo: {
      type: String,
      default: '主图'
    },
    isShowUploadError: {
      type: Boolean,
      default: true
    },
    isShowUploadSuccess: {
      type: Boolean,
      default: false
    },
    zzapp: {
      type: Boolean,
      default: true
    },
    zzhunter: {
      type: Boolean,
      default: true
    },
    zlj: {
      type: Boolean,
      default: true
    },
    weixin: {
      type: Boolean,
      default: false
    },
    videoCover: {
      type: String,
      default: 'https://pic1.zhuanstatic.com/zhuanzh/n_v222a9cf9709f1463cabcdd76c2e4a4de8.png'
    },
    imageBgSize: {
      type: String,
      default: 'cover'
    },
    uploadWeixinOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadPhotoshParameter: {
      type: Object,
      default: function _default() {
        return {
          businessType: '1',
          supportEdit: '1'
        };
      }
    },
    chooseMediaPhotosParameter: {
      type: Object,
      default: function _default() {
        return {
          videoLength: '600',
          isNeedShowVideo: '0',
          maxImagesCount: '10',
          maxVideosCount: '10',
          requestId: '1',
          supportEdit: '1',
          businessType: '1',
          isShowVideoList: '1'
        };
      }
    },
    getSystemCameraParameter: {
      type: Object,
      default: function _default() {}
    },
    getVideoRecorderParameter: {
      type: Object,
      default: function _default() {}
    },
    isBtnFlex: {
      type: Boolean,
      default: false
    },
    isAppUploadLoading: {
      type: Boolean,
      default: false
    },
    selectImageV2: {
      type: Boolean,
      default: false
    },
    selectImageV2params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    filterError: {
      type: Boolean,
      default: false
    },
    btnUploadImg: {
      type: String,
      default: 'https://pic1.zhuanstatic.com/zhuanzh/e09af7a8-345a-4030-be66-af308961a664.png'
    },
    btnUploadInfo: {
      type: String,
      default: '添加照片/视频'
    },
    zzStoreCapture: {
      type: Boolean,
      default: false
    },
    imgMax: {
      type: Number,
      default: 0
    },
    videoMax: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      files: this.value,
      paused: !this.auto,
      maxAllowApp: this.max,
      weixinUpload: null,
      weixinInitReady: false,
      cdnSdkLoaded: false,
      isAdaptIosUplaod: false,
      isSupportNewUploadApi: (0, _utils.checkSdkSupport)('10.5.0')
    };
  },
  computed: {
    actionOptions: function actionOptions() {
      var action = this.action;
      if (!action || typeof action === 'string') {
        return {
          target: action || ''
        };
      } else {
        return action;
      }
    },
    isShowBtn: function isShowBtn() {
      return this.files.length < this.max;
    },
    initReady: function initReady() {
      return this.weixinInitReady && this.cdnSdkLoaded;
    }
  },
  watch: {
    value: function value(newVal) {
      this.files = newVal;
      this.maxAllowApp = this.max - newVal.length;
    },
    files: function files(newFiles) {
      if (this.isShowCoverInfo && !this.coverInfoVideo) {
        // 如果第一张不是图片，把最近的图片放到第一个的位置
        if (newFiles.length && newFiles[0].type && newFiles[0].type.indexOf('image') === -1) {
          var imgIndex = -1;
          newFiles.forEach(function (item, index) {
            if (item.type && item.type.indexOf('image') !== -1 && imgIndex === -1) {
              imgIndex = index;
            }
          });
          if (imgIndex !== -1) {
            var firstImg = newFiles.splice(imgIndex, 1)[0];
            newFiles.unshift(firstImg);
          }
        }
      }
      this.$emit(EVENT_INPUT, newFiles);
    },
    accept: function accept(newVal) {
      this.loadCdnSdk();
    }
  },
  created: function created() {
    if (/iphone/.test(_utils.UA)) {
      var version = (0, _util.getiPhoneVersion)(_utils.UA);
      if ((0, _utils.compareVersion)('10.29', version) === 1 && this.accept.includes('video')) {
        this.isAdaptIosUplaod = true;
      }
    }
  },
  mounted: function mounted() {
    if (!_utils.isServer && this.$expandAdapter) adapter = this.$expandAdapter;
    this.loadCdnSdk();
    this.initWeixin();
  },
  methods: {
    initWeixin: function initWeixin() {
      var _this = this;
      if (this.weixin && _utils.isWechat) {
        adapter.initWxConfig(function () {
          _this.weixinUpload = new _uplaodWeixin.default(_this.uploadWeixinOptions, _this.capture);
          _this.weixinInitReady = true;
        });
      } else {
        this.weixinInitReady = true;
      }
    },
    // 由 btn.vue 组件调用，向使用者派发视频正在上传事件，data变量由jssdk传递而来。
    emitUploadingEvent: function emitUploadingEvent(data) {
      this.$emit(EVENT_UPLOADING, data);
    },
    loadCdnSdk: function loadCdnSdk() {
      var _this2 = this;
      if (!this.cdnSdkLoaded && this.accept.indexOf('video') !== -1) {
        var jquery = 'https://s1.zhuanstatic.com/common/system/js/jquery-1.12.4.min.js';
        var wos = 'https://s1.zhuanstatic.com/common/system/wos-js-sdk-v2.ajksdhkjas.js';
        var cos = 'https://s1.zhuanstatic.com/common/trade/cos-js-sdk-v5.min.js';
        if (this.actionOptions.tencentCdnOpt) {
          (0, _util.loadJs)(cos, function () {
            _this2.cdnSdkLoaded = true;
          });
        } else {
          (0, _util.loadJs)(jquery, function () {
            (0, _util.loadJs)(wos, function () {
              _this2.cdnSdkLoaded = true;
            });
          });
        }
      } else {
        this.cdnSdkLoaded = true;
      }
    },
    // 处理新版sdk端内的添加文件
    addAppFilesV3: function addAppFilesV3(files) {
      var i = 0;
      var file = files[i];
      while (this.files.length <= this.max && file) {
        var fileNames = this.files.map(function (value) {
          return value.name;
        });
        if (fileNames.includes(file.name)) {
          var index = fileNames.indexOf(file.name);
          this.$set(this.files, index, {
            progress: file.progress,
            response: file.response,
            status: file.status,
            url: file.url,
            name: file.name,
            type: 'image/jpg',
            base64: file.base64 ? file.base64 : this.files[index].base64,
            urlName: file.urlName
          });
        } else {
          this.files.push(file);
        }
        var event = file.status === 'success' ? EVENT_SUCCESS : file.status === 'error' ? EVENT_ERROR : EVENT_UPLOADING;
        this.$emit(event, file);
        file = files[++i];
      }
    },
    // 处理端内的添加文件
    addAppFiles: function addAppFiles(files) {
      var filesLen = this.files.length;
      var newFiles = [];
      var maxLen = this.max - filesLen;
      var i = 0;
      var file = files[i];
      while (newFiles.length < maxLen && file) {
        if (!file.ignore) {
          newFiles.push(file);
          this.files.push(file);
          if (file.name !== 'zzapp_stance') {
            this.$emit(file.status === _util.STATUS_SUCCESS ? EVENT_SUCCESS : EVENT_ERROR, file);
          }
        }
        file = files[++i];
      }
    },
    addFiles: function addFiles(files) {
      var _this3 = this;
      this.$emit(EVENT_ADDED, files);
      var filesLen = this.files.length;
      var newFiles = [];
      var maxLen = this.max - filesLen;
      var i = 0;
      var file = files[i];
      while (newFiles.length < maxLen && file) {
        if (!file.ignore) {
          newFiles.push(file);
          var newfile = (0, _util.newFile)();
          // newfile.response = this.videoCover;
          this.files.push(newfile);
        }
        file = files[++i];
      }
      // 区分视频和图片 图片进行处理，视频不做处理

      (0, _util.processFiles)(newFiles, this.processFile, function (file, index) {
        _this3.$set(_this3.files, filesLen + index, file);
        _this3.$emit(EVENT_SUBMITTED, file);
      }, function () {
        // waiting ui
        _this3.$nextTick(function () {
          _this3.upload();
        });
      });
    },
    removeFile: function removeFile(file, emit) {
      if (emit === void 0) {
        emit = true;
      }
      console.log('removeFile', file, emit);
      console.log('removeFile', this.files);
      file._xhr && file._xhr.abort();
      file.url && _util.URL.revokeObjectURL(file.url);
      var index = this.files.findIndex(function (item) {
        return file === item || file === item.name || file.name === item.name;
      });
      index > -1 && this.files.splice(index, 1);
      if (emit) {
        this.$emit(EVENT_REMOVED, file);
        this.upload();
      }
    },
    removeFileAll: function removeFileAll() {
      this.files.splice(0, this.files.length);
    },
    fileClick: function fileClick(file) {
      this.$emit(EVENT_CLICK, file);
    },
    upload: function upload(retry) {
      var _this4 = this;
      if (this.paused) {
        return;
      }
      var options = Object.assign({
        videoCover: this.videoCover
      }, this.actionOptions);
      var len = this.files.length;
      var uploadingCount = 0;
      var i = 0;
      var _loop = function _loop() {
        var file = _this4.files[i];
        var status = file.status;
        if (status === _util.STATUS_READY || retry && status === _util.STATUS_ERROR && file._retryId !== _this4.retryId) {
          var cb = function cb(res) {
            if (status === _util.STATUS_ERROR) {
              res._retryId = _this4.retryId;
            }
            if (_this4.dropOriginFile) {
              delete res.base64;
              delete res.file;
            }
            _this4.$emit(res.status === _util.STATUS_SUCCESS ? EVENT_SUCCESS : EVENT_ERROR, res);
            _this4.upload(retry);
          };

          // 区分视频和图片使用不同的上传函数
          if (file && file.type && file.type.indexOf('image') !== -1) {
            (0, _uploadPic.default)(file, options, cb);
          } else {
            options.tencentCdnOpt ? (0, _uploadCos.default)(file, options, cb) : (0, _uploadWos.default)(file, options, cb);
          }
          uploadingCount++;
        } else if (status === _util.STATUS_UPLOADING) {
          uploadingCount++;
        }
        i++;
      };
      while (i < len && uploadingCount < this.simultaneousUploads) {
        _loop();
      }
    },
    start: function start() {
      this.paused = false;
      this.upload();
    },
    pause: function pause() {
      this.paused = true;
      this.files.forEach(function (file) {
        if (file.status === _util.STATUS_UPLOADING) {
          file._xhr.abort();
          file.status = _util.STATUS_READY;
        }
      });
    },
    retry: function retry() {
      this.retryId = Date.now();
      this.paused = false;
      this.upload(true);
    },
    // 外部方法，用户可调用，全部上传成功
    isComplete: function isComplete() {
      return this.files.every(function (item) {
        return item.status === _util.STATUS_SUCCESS;
      });
    },
    // 外部方法，用户可调用，全部上传完毕，可以不是都成功
    isFinished: function isFinished() {
      return this.files.every(function (item) {
        return item.status === _util.STATUS_SUCCESS || item.status === _util.STATUS_ERROR;
      });
    }
  }
};
exports.default = _default2;